<template>
  <section>
    <ViewProgramDetailsSeasonsSeason
      v-for="(season, index) in seasons"
      :key="season.name"
      :initially-expanded="index === 0"
      :length="seasons.length"
      :mailto="mailto"
      v-bind="season"
    />
  </section>
</template>

<script>
  import ViewProgramDetailsSeasonsSeason from './ViewProgramDetailsSeasonsSeason';

  export default {
    components: { ViewProgramDetailsSeasonsSeason },
    props: {
      seasons: {
        type: Array,
        required: true,
      },
      mailto: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>

</style>
